import { render } from "./HelixTabs.vue?vue&type=template&id=0daca6eb&scoped=true"
import script from "./HelixTabs.vue?vue&type=script&lang=js"
export * from "./HelixTabs.vue?vue&type=script&lang=js"

import "./HelixTabs.vue?vue&type=style&index=0&id=0daca6eb&lang=scss&scoped=true"

import exportComponent from "/var/lib/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0daca6eb"]])

export default __exports__